import * as z from 'zod';

import { isEmpty } from '@hsp/utilities';

import { ExternalListStatusSchema, TagSchema } from 'types/api';
import { ClientSchema } from 'types/api/client';
import { s } from 'utilities';

export const UploadListFormSchema = z.object({
  client: ClientSchema,
  file: z
    .any()
    .refine((files) => files?.length === 1, s('Site.Pages.AudienceBuilder.ExternalList.Form.Validation.File'))
    .refine(
      (files) => ['text/csv'].includes(files?.[0]?.type),
      s('Site.Pages.AudienceBuilder.ExternalList.Form.Validation.Csv')
    ),
  fileName: z.string().trim().nonempty(s('Site.Pages.AudienceBuilder.ExternalList.Form.Validation.Name')),
  status: ExternalListStatusSchema.optional(),
  tags: z.array(TagSchema).optional(),
});

export const UploadListFormSchemaOptionalFile = z.object({
  client: ClientSchema,
  file: z
    .any()
    .refine(
      (files) => isEmpty(files) || ['text/csv'].includes(files?.[0]?.type),
      s('Site.Pages.AudienceBuilder.ExternalList.Form.Validation.Csv')
    )
    .optional(),
  fileName: z.string().trim().nonempty(s('Site.Pages.AudienceBuilder.ExternalList.Form.Validation.Name')),
  status: ExternalListStatusSchema.optional(),
  tags: z.array(TagSchema).optional(),
});

export type UploadListForm = z.infer<typeof UploadListFormSchema> | z.infer<typeof UploadListFormSchemaOptionalFile>;
